import { Group, SpotLight } from 'three';

/** Two headlight beams on the player's trotro. Switching them on or off changes how many lights the scene has. */
export function createHeadlights(frontZ: number, halfWidth: number): Group {
  const group = new Group();
  for (const side of [-1, 1]) {
    const beam = new SpotLight('#fff1cf', 900, 70, 0.5, 0.55, 1.6);
    beam.position.set(side * halfWidth * 0.6, 0.8, frontZ + 0.2);
    beam.target.position.set(side * halfWidth * 0.5, 0, frontZ - 24);
    group.add(beam, beam.target);
  }
  group.visible = false;
  return group;
}
